import { Component, input } from '@angular/core';

import {
  ModalHeaderButtonsComponent,
  ModalHeaderCloseButtonComponent,
  ModalHeaderComponent,
  ModalHeaderTitleComponent
} from '@tdwb/core';

@Component({
  imports: [
    ModalHeaderComponent,
    ModalHeaderTitleComponent,
    ModalHeaderButtonsComponent,
    ModalHeaderCloseButtonComponent
  ],
  selector: 'td-wb-modal-notification-header',
  templateUrl: 'modal-notification-header.component.html',
  styleUrls: ['modal-notification-header.component.scss']
})
export class ModalNotificationHeaderComponent {
  readonly iconId = input('modal--info');
  readonly modalTitle = input('tdWb.modalNotification.header.NOTIFICATION_MODAL_TITLE');
}
